import { Flex, P } from "orcs-design-system";
import React, { useState } from "react";

import CodeEditorField from "./CodeEditorField";
import { useDashboardData } from "./DashboardDataContext";
import { Tab, TabBar } from "./editor.styled";

const TABS = [
  { key: "queries", label: "Queries" },
  { key: "results", label: "Results" },
];

const QueriesEditor = () => {
  const [activeTab, setActiveTab] = useState("queries");
  const { localQuery, parseError, queryData, setLocalQuery } =
    useDashboardData();

  return (
    <Flex flexDirection="column" gap="s">
      <TabBar>
        {TABS.map((tab) => (
          <Tab
            key={tab.key}
            type="button"
            $active={activeTab === tab.key}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabBar>
      {activeTab === "queries" && (
        <CodeEditorField
          value={localQuery}
          onChange={setLocalQuery}
          lang="graphql"
        />
      )}
      {activeTab === "results" && (
        <>
          {parseError && (
            <P color="danger" fontSize="1" mt="xs">
              Parse error: {parseError}
            </P>
          )}
          {queryData && Object.keys(queryData).length > 0 && (
            <CodeEditorField
              value={JSON.stringify(queryData, null, 2)}
              onChange={() => {}}
              lang="json"
              editable={false}
            />
          )}
        </>
      )}
    </Flex>
  );
};

export default QueriesEditor;
